(function () {
  'use strict';

  var SCHEMA_VERSION = '1.0';
  var seen = new Set();
  var OPTIONAL_PARAMETERS = [
    'source_component',
    'component_action',
    'interaction_location',
    'display_mode',
    'destination_type',
    'quiz_variant',
    'quiz_step',
    'quiz_step_total',
    'item_id',
    'item_name',
    'item_count',
    'quantity',
    'article_handle'
  ];

  function pageTemplate() {
    var main = document.querySelector('main[data-template]');
    return main ? String(main.getAttribute('data-template') || '') : '';
  }

  function clean(value) {
    if (value === undefined || value === null || value === '') return undefined;
    return value;
  }

  function push(eventName, parameters) {
    if (!eventName) return;
    // The isolated planner must never queue analytics before consent.
    if (parameters && /^veteran_/.test(parameters.source_component || '') && !analyticsAllowed()) return;
    window.dataLayer = window.dataLayer || [];

    var payload = {
      event: String(eventName),
      measurement_schema_version: SCHEMA_VERSION,
      site_code: 'bsn',
      page_template: pageTemplate()
    };

    // GTM data-layer values persist between pushes. Clear optional values so
    // item, quiz, or navigation context cannot leak into the next event.
    OPTIONAL_PARAMETERS.forEach(function (key) {
      payload[key] = null;
    });

    Object.keys(parameters || {}).forEach(function (key) {
      var value = clean(parameters[key]);
      if (value !== undefined) payload[key] = value;
    });

    window.dataLayer.push(payload);
  }

  function once(key, callback) {
    if (!key || seen.has(key)) return false;
    seen.add(key);
    callback();
    return true;
  }

  function componentView(sourceComponent, parameters, key) {
    var onceKey = key || ['view', sourceComponent, pageTemplate()].join(':');
    return once(onceKey, function () {
      push('component_view', Object.assign({ source_component: sourceComponent }, parameters || {}));
    });
  }

  function componentInteraction(sourceComponent, componentAction, parameters) {
    push('component_interaction', Object.assign({
      source_component: sourceComponent,
      component_action: componentAction
    }, parameters || {}));
  }

  function toolEvent(eventName, sourceComponent, parameters) {
    push(eventName, Object.assign({ source_component: sourceComponent }, parameters || {}));
  }

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      // Honor an explicit refusal even if regional defaults allow processing.
      // Otherwise retain Shopify's region-aware permission decision.
      return Boolean(privacy && privacy.currentVisitorConsent().analytics !== 'no'
        && privacy.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  window.BSNMeasurement = {
    schemaVersion: SCHEMA_VERSION,
    push: push,
    once: once,
    componentView: componentView,
    componentInteraction: componentInteraction,
    toolEvent: toolEvent,
    analyticsAllowed: analyticsAllowed
  };

  function slug(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 60);
  }

  function topNavAction(details) {
    if (details.id === 'Details-menu-drawer-container') return 'open_navigation';
    var summary = details.querySelector(':scope > summary');
    var label = summary ? slug(summary.textContent) : '';
    return label ? 'open_' + label : 'open_menu';
  }

  function initializeTopNavigationMeasurement() {
    var header = document.querySelector('.shopify-section-header, header');
    if (!header) return;

    var viewParameters = {
      interaction_location: 'site_header',
      display_mode: 'navigation'
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        componentView('top_nav', viewParameters, 'view:top-nav');
        observer.disconnect();
      });
      observer.observe(header);
    } else {
      componentView('top_nav', viewParameters, 'view:top-nav');
    }

    document.addEventListener('toggle', function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open || !header.contains(details)) return;

      var isMobileDrawer = details.id === 'Details-menu-drawer-container'
        || Boolean(details.closest('#Details-menu-drawer-container'));
      var isDesktopMenu = details.classList.contains('mega-menu');
      if (!isMobileDrawer && !isDesktopMenu) return;

      componentInteraction('top_nav', topNavAction(details), {
        interaction_location: isMobileDrawer ? 'header_mobile' : 'header_desktop',
        display_mode: isMobileDrawer ? 'drawer' : 'dropdown'
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTopNavigationMeasurement, { once: true });
  } else {
    initializeTopNavigationMeasurement();
  }
}());
